// extracted by mini-css-extract-plugin
export default {"tutWrap":"Instruction_tutWrap__-6uH8","tutBtn":"Instruction_tutBtn__eaSCQ","slideOpen":"Instruction_slideOpen__Is87v","slideClose":"Instruction_slideClose__NcPNQ"};